var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.355,
    height: 22.267,
    viewBox: "0 0 20.355 22.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Manual",
    "data-name": "User Manual",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21730",
    "data-name": "Group 21730",
    transform: "translate(0.448 0.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21685",
    "data-name": "Group 21685",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21638",
    "data-name": "Group 21638",
    transform: "translate(1.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21637",
    "data-name": "Group 21637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21636",
    "data-name": "Group 21636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21635",
    "data-name": "Group 21635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21634",
    "data-name": "Group 21634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170769",
    "data-name": "Path 170769",
    d: "M70.723,55.006H55.989a.672.672,0,0,1-.672-.672V34.607a.672.672,0,0,1,.672-.672H70.723a.672.672,0,0,1,.672.672V54.334A.672.672,0,0,1,70.723,55.006Z",
    transform: "translate(-55.317 -33.935)",
    fill: "#00a99d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21684",
    "data-name": "Group 21684",
    transform: "translate(0 2.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21643",
    "data-name": "Group 21643",
    transform: "translate(1.863 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21642",
    "data-name": "Group 21642",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21641",
    "data-name": "Group 21641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21640",
    "data-name": "Group 21640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21639",
    "data-name": "Group 21639"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    transform: "matrix(0.391, -0.92, 0.92, 0.391, 0, 1.831)",
    fill: "#3f348b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21648",
    "data-name": "Group 21648",
    transform: "translate(2.172 4.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21647",
    "data-name": "Group 21647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21646",
    "data-name": "Group 21646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21645",
    "data-name": "Group 21645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21644",
    "data-name": "Group 21644"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    fill: "#3f348b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21653",
    "data-name": "Group 21653",
    transform: "translate(1.868 8.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21652",
    "data-name": "Group 21652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21651",
    "data-name": "Group 21651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21650",
    "data-name": "Group 21650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21649",
    "data-name": "Group 21649"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    transform: "translate(0 1.837) rotate(-67.5)",
    fill: "#3f348b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21658",
    "data-name": "Group 21658",
    transform: "translate(2.172 12.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21657",
    "data-name": "Group 21657",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21656",
    "data-name": "Group 21656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21655",
    "data-name": "Group 21655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21654",
    "data-name": "Group 21654"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 0.994,
    cy: 0.994,
    r: 0.994,
    fill: "#3f348b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21683",
    "data-name": "Group 21683",
    transform: "translate(0 0.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21664",
    "data-name": "Group 21664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21663",
    "data-name": "Group 21663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21662",
    "data-name": "Group 21662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21661",
    "data-name": "Group 21661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21660",
    "data-name": "Group 21660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21659",
    "data-name": "Group 21659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170770",
    "data-name": "Path 170770",
    d: "M45.561,67.5H43.107a.635.635,0,0,1-.635-.635h0a.635.635,0,0,1,.635-.635h2.454a.635.635,0,0,1,.635.635h0A.635.635,0,0,1,45.561,67.5Z",
    transform: "translate(-42.472 -66.235)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21670",
    "data-name": "Group 21670",
    transform: "translate(0 4.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21669",
    "data-name": "Group 21669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21668",
    "data-name": "Group 21668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21667",
    "data-name": "Group 21667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21666",
    "data-name": "Group 21666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21665",
    "data-name": "Group 21665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170771",
    "data-name": "Path 170771",
    d: "M45.561,104.9H43.107a.635.635,0,0,1-.635-.635h0a.635.635,0,0,1,.635-.635h2.454a.635.635,0,0,1,.635.635h0A.635.635,0,0,1,45.561,104.9Z",
    transform: "translate(-42.472 -103.633)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21676",
    "data-name": "Group 21676",
    transform: "translate(0 8.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21675",
    "data-name": "Group 21675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21674",
    "data-name": "Group 21674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21673",
    "data-name": "Group 21673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21672",
    "data-name": "Group 21672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21671",
    "data-name": "Group 21671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170772",
    "data-name": "Path 170772",
    d: "M45.561,142.3H43.107a.635.635,0,0,1-.635-.635h0a.635.635,0,0,1,.635-.635h2.454a.635.635,0,0,1,.635.635h0A.635.635,0,0,1,45.561,142.3Z",
    transform: "translate(-42.472 -141.032)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21682",
    "data-name": "Group 21682",
    transform: "translate(0 12.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21681",
    "data-name": "Group 21681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21680",
    "data-name": "Group 21680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21679",
    "data-name": "Group 21679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21678",
    "data-name": "Group 21678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21677",
    "data-name": "Group 21677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170773",
    "data-name": "Path 170773",
    d: "M45.561,179.7H43.107a.635.635,0,0,1-.635-.635h0a.635.635,0,0,1,.635-.635h2.454a.635.635,0,0,1,.635.635h0A.635.635,0,0,1,45.561,179.7Z",
    transform: "translate(-42.472 -178.432)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21720",
    "data-name": "Group 21720",
    transform: "translate(6.368 6.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21719",
    "data-name": "Group 21719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21718",
    "data-name": "Group 21718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21717",
    "data-name": "Group 21717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21716",
    "data-name": "Group 21716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21715",
    "data-name": "Group 21715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21689",
    "data-name": "Group 21689",
    transform: "translate(0.808 1.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21688",
    "data-name": "Group 21688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21687",
    "data-name": "Group 21687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21686",
    "data-name": "Group 21686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170774",
    "data-name": "Path 170774",
    d: "M98.907,88.521a3.207,3.207,0,1,0,3.207,3.207A3.207,3.207,0,0,0,98.907,88.521Zm0,4.928a1.72,1.72,0,1,1,1.72-1.72A1.72,1.72,0,0,1,98.907,93.449Z",
    transform: "translate(-95.7 -88.521)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21714",
    "data-name": "Group 21714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21693",
    "data-name": "Group 21693",
    transform: "translate(6.187 1.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21692",
    "data-name": "Group 21692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21691",
    "data-name": "Group 21691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21690",
    "data-name": "Group 21690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170775",
    "data-name": "Path 170775",
    d: "M162.867,96.609l.78-.688a.329.329,0,0,0,.067-.411l-.415-.718a.329.329,0,0,0-.39-.147l-.995.334A3.2,3.2,0,0,1,162.867,96.609Z",
    transform: "translate(-161.915 -94.627)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21697",
    "data-name": "Group 21697",
    transform: "translate(0 1.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21696",
    "data-name": "Group 21696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21695",
    "data-name": "Group 21695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21694",
    "data-name": "Group 21694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170776",
    "data-name": "Path 170776",
    d: "M85.868,95.922l.78.688a3.2,3.2,0,0,1,.952-1.63l-.994-.334a.329.329,0,0,0-.39.147l-.415.718A.329.329,0,0,0,85.868,95.922Z",
    transform: "translate(-85.757 -94.628)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21701",
    "data-name": "Group 21701",
    transform: "translate(3.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21700",
    "data-name": "Group 21700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21699",
    "data-name": "Group 21699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21698",
    "data-name": "Group 21698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170777",
    "data-name": "Path 170777",
    d: "M124.558,75.811a3.207,3.207,0,0,1,.939.14l-.2-1a.329.329,0,0,0-.322-.264h-.829a.329.329,0,0,0-.322.264l-.2,1A3.207,3.207,0,0,1,124.558,75.811Z",
    transform: "translate(-123.619 -74.687)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21705",
    "data-name": "Group 21705",
    transform: "translate(6.215 5.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21704",
    "data-name": "Group 21704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21703",
    "data-name": "Group 21703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21702",
    "data-name": "Group 21702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170778",
    "data-name": "Path 170778",
    d: "M163.937,137.418l-.75-.662a3.2,3.2,0,0,1-.928,1.622l.941.316a.329.329,0,0,0,.39-.147l.415-.718A.329.329,0,0,0,163.937,137.418Z",
    transform: "translate(-162.259 -136.756)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21709",
    "data-name": "Group 21709",
    transform: "translate(3.076 7.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21708",
    "data-name": "Group 21708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21707",
    "data-name": "Group 21707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21706",
    "data-name": "Group 21706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170779",
    "data-name": "Path 170779",
    d: "M124.558,165.9a3.207,3.207,0,0,1-.939-.14l.2,1a.329.329,0,0,0,.322.264h.829a.329.329,0,0,0,.322-.264l.2-1A3.207,3.207,0,0,1,124.558,165.9Z",
    transform: "translate(-123.619 -165.759)",
    fill: "#3f348b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21713",
    "data-name": "Group 21713",
    transform: "translate(0.025 5.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21712",
    "data-name": "Group 21712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21711",
    "data-name": "Group 21711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21710",
    "data-name": "Group 21710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170780",
    "data-name": "Path 170780",
    d: "M86.93,136.757l-.75.662a.329.329,0,0,0-.067.411l.415.718a.329.329,0,0,0,.39.147l.941-.316A3.2,3.2,0,0,1,86.93,136.757Z",
    transform: "translate(-86.068 -136.757)",
    fill: "#3f348b"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21729",
    "data-name": "Group 21729",
    transform: "translate(17.517 2.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21722",
    "data-name": "Group 21722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21721",
    "data-name": "Group 21721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170781",
    "data-name": "Path 170781",
    d: "M200.064,60.6H198.87V57.179h1.194a.448.448,0,0,1,.448.448v2.521A.448.448,0,0,1,200.064,60.6Z",
    transform: "translate(-198.87 -57.179)",
    fill: "#bce037"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21724",
    "data-name": "Group 21724",
    transform: "translate(0 4.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21723",
    "data-name": "Group 21723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170782",
    "data-name": "Path 170782",
    d: "M200.064,97.641H198.87V94.224h1.194a.448.448,0,0,1,.448.448v2.521A.448.448,0,0,1,200.064,97.641Z",
    transform: "translate(-198.87 -94.224)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21726",
    "data-name": "Group 21726",
    transform: "translate(0 8.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21725",
    "data-name": "Group 21725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170783",
    "data-name": "Path 170783",
    d: "M200.064,134.686H198.87v-3.417h1.194a.448.448,0,0,1,.448.448v2.521A.448.448,0,0,1,200.064,134.686Z",
    transform: "translate(-198.87 -131.269)",
    fill: "#3f348b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21728",
    "data-name": "Group 21728",
    transform: "translate(0 12.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21727",
    "data-name": "Group 21727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170784",
    "data-name": "Path 170784",
    d: "M200.064,171.73H198.87v-3.417h1.194a.448.448,0,0,1,.448.448v2.521A.448.448,0,0,1,200.064,171.73Z",
    transform: "translate(-198.87 -168.313)",
    fill: "#e01b85"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21731",
    "data-name": "Group 21731",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170785",
    "data-name": "Path 170785",
    d: "M58.528,35.956V33.434a.9.9,0,0,0-.9-.9h-.746V31.055a1.121,1.121,0,0,0-1.12-1.12H41.032a1.121,1.121,0,0,0-1.12,1.12v2.5h-.356a1.083,1.083,0,0,0,0,2.165h.356v2.023h-.356a1.083,1.083,0,0,0,0,2.165h.356v2.023h-.356a1.083,1.083,0,1,0,0,2.165h.356v2.023h-.356a1.083,1.083,0,1,0,0,2.165h.356v2.5a1.121,1.121,0,0,0,1.12,1.12H55.766a1.121,1.121,0,0,0,1.12-1.12V49.3h.746a.9.9,0,0,0,.9-.9V45.882a.9.9,0,0,0-.522-.814.9.9,0,0,0,.522-.814V41.733a.9.9,0,0,0-.522-.814.9.9,0,0,0,.522-.814V37.584a.9.9,0,0,0-.522-.814A.9.9,0,0,0,58.528,35.956Zm-.448,0a.448.448,0,0,1-.448.448H56.438v.732h1.194a.448.448,0,0,1,.448.448V40.1a.448.448,0,0,1-.448.448H56.438v.732h1.194a.448.448,0,0,1,.448.448v2.521a.448.448,0,0,1-.448.448H56.438v.732h1.194a.448.448,0,0,1,.448.448V48.4a.448.448,0,0,1-.448.448H56.438v1.931a.672.672,0,0,1-.672.672H41.032a.672.672,0,0,1-.672-.672V47.837h-.8a.635.635,0,0,1,0-1.269h.8V43.648h-.8a.635.635,0,1,1,0-1.269h.8V39.459h-.8a.635.635,0,0,1,0-1.269h.8V35.27h-.8a.635.635,0,0,1,0-1.269h.8V31.055a.672.672,0,0,1,.672-.672H55.766a.672.672,0,0,1,.672.672v1.931h1.194a.448.448,0,0,1,.448.448Z",
    transform: "translate(-38.473 -29.935)",
    fill: "#3f348b",
    stroke: "#3f348b",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManual);
export default __webpack_public_path__ + "static/media/UserManual.bc4a938576abd40f8e0f392d294ca98c.svg";
export { ForwardRef as ReactComponent };